<template>
  <div>
    <div class="tsk_remark-list">
      <div v-if="!isEmpty">
      <div
        class="remarklist-item"
        v-for="item in remarkList"
        :key="item.tskRemarkCode"
      >
        <CollapseGruop class="pt-4">
          <div class="default-back-pd" style="padding-bottom: 2px">
            <CollapseItem
              :item="item"
              @edit="onEdit"
              @delete="onDelete"
              @reply="onReply"
            >
              <div class="remark-content" v-html="item.remark || ''"></div>
              <TaskFile
                style="margin-bottom: 10px"
                :fileIcons="fileIcons"
                :tskInfoDocList="item.tskInfoDocList"
                v-if="showTaskFile(item)"
                />
              </CollapseItem>
            </div>
          </CollapseGruop>
        </div>
      </div>
      <div v-else>
        <div style="text-align: center" class="mt-4">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>

    <EditForm
      :visible.sync="editOptions.visible"
      :type="editOptions.type"
      :tskRemarkCode="editOptions.tskRemarkCode"
      :linkUserCodes="editOptions.linkUserCodes"
      :expoMeetingCode="expoMeetingCode"
      :tskInfoCode="tskInfoCode"
      @reload="getData"
    />
  </div>
</template>
<script>
import 'dayjs/locale/zh-cn'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import EditForm from './edit-form'
import CollapseGruop from './collapse/gruop.vue'
import CollapseItem from './collapse/item.vue'
import TaskFile from './task-file'
import { request } from '@/api/service'
import EditLoading from '@/mixins/edit-loading'

dayjs.extend(relativeTime)
export default {
  mixins: [EditLoading],
  props: {
    tskInfoCode: { type: String, default: '' },
    expoMeetingCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  components: { EditForm, CollapseGruop, CollapseItem, TaskFile },
  data() {
    return {
      editOptions: {
        visible: false,
        type: '',
        tskRemarkCode: '',
        linkUserCodes: [],
      },
      remarkList: [],
      fileIcons: {},
      localTimeZone: '',
    }
  },
  async mounted() {
    await this.getFileIcons()
    this.getData()
  },
  computed: {
    isEmpty() {
      return !this.remarkList || this.remarkList.length === 0
    },
  },
  methods: {
    openEdit({ type, tskRemarkCode }) {
      this.editOptions.tskRemarkCode = tskRemarkCode
      this.editOptions.type = type
      this.editOptions.visible = true
    },
    async loadLocalTimeZone() {
      return new Promise((resolve) => {
        if (this.localTimeZone) return resolve(this.localTimeZone)
        const now = new Date()
        const offsetMinutes = now.getTimezoneOffset()
        const offsetHours = Math.abs(Math.floor(offsetMinutes / 60))
        const offsetMinutesRemainder = Math.abs(offsetMinutes % 60)
        const offsetString = `${
          offsetMinutes >= 0 ? '-' : '+'
        }${offsetHours
          .toString()
          .padStart(2, '0')}:${offsetMinutesRemainder
          .toString()
          .padStart(2, '0')}`

        this.localTimeZone = offsetString
        resolve(offsetString)
      })
    },
    showTaskFile({ tskInfoDocList = [] }) {
      return tskInfoDocList?.length > 0
    },
    async getFileIcons() {
      const res = await request({
        url: '/sys/common/dict/system',
        method: 'POST',
        data: { dictType: 'FileTypeIcon' },
      }).catch(() => null)

      const data = res?.body?.data || []
      this.fileIcons = Object.fromEntries(
        data.map(({ value, label }) => [value, label])
      )
    },
    async getData() {
      const localTimeZone = await this.loadLocalTimeZone()
      const res = await this.$api
        .personalTskRemarkListApi({
          tskInfoCode: this.tskInfoCode,
          localTimeZone,
        })
        .catch(() => null)
      this.remarkList = []
      const data = res?.body?.data || []
      if (!data?.length) return
      this.remarkList = data.map((item) => {
        let { remarkTime } = item
        const t = {
          ...item,
          remarkTimeLocale: dayjs(remarkTime)
            .locale('zh-cn')
            .fromNow(),
        }

        // if (logContent && logType == 'D') {
        //   logContent = JSON.parse(logContent)
        //   logContent = logContent.map((c) => ({
        //     ...c,
        //     fileIcon: this.getFileIcon(c.fileName),
        //   }))
        // }

        return { ...t }
      })
    },

    onEdit({ tskRemarkCode }) {
      this.openEdit({ type: 'edit', tskRemarkCode })
    },
    async onDelete({ tskRemarkCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .personalTskRemarkDelApi({ tskRemarkCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      await this.getData()
    },
    async onReply({ tskRemarkCode }) {
      const res = await this.$api
        .personalTskRemarkDetailApi({
          tskRemarkCode: tskRemarkCode,
        })
        .catch(() => null)
      if (!res) return
      const linkUserCodes = res.body.linkUserCodes || []
      this.editOptions.linkUserCodes = linkUserCodes
      this.editOptions.tskRemarkCode = ''
      this.editOptions.type = 'reply'
      this.editOptions.visible = true
    },
    download({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
  },
}
</script>
<style lang="scss" scoped>
.remark-content {
  font-size: 14px;
}
.remarklist-item {
  box-shadow: 0 0.35rem 0.5rem 0 rgba(0, 0, 0, 0.08);
}
</style>
